<svg
    width="376"
    height="212"
    viewBox="0 0 376 212"
    xmlns="http://www.w3.org/2000/svg">
 <!-- Roof Border -->


    <!-- Roof -->
    <svg:path
    class="single-roof"
    d="M187 211 L0 101 L187 0 L375 102 L187 211 Z" />

    <g
        transform="translate(35, -70)"
        [width]="300"
        [height]="300"
        app-roof-box></g>

    <g
        app-square-box
        [width]="200"
        [height]="200"
        [x]="-20"
        [y]="80"></g>

    <g
        app-square-box
        [width]="200"
        [height]="200"
        [x]="30"
        [y]="110"></g> 


</svg>